// components/AuthModal.js
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './assets/style.scss';
import { getAuth, updateAuth } from '../../utils/localStoreHelper';
import { URL_AUTH } from '../../utils/Constant';

const AuthModal = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector(state => state.auth.modal);

  const handleLogin = () => {
    dispatch({
      type: 'SET_AUTH_MODAL',
      data: { modal: false }
    });
    const auth = getAuth();
    window.location.href = auth.url ? auth.url : URL_AUTH;
  };

  const handleStayGuest = () => {
    dispatch({
      type: 'SET_AUTH_MODAL',
      data: { modal: false }
    });  
    // Очищаем авторизационные данные и ставим гостя
    updateAuth({token: undefined, isGuest: true});
    // нужно перезапросить данные уже как гость
    window.location.reload();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="auth-modal-overlay" onClick={handleStayGuest}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal-header">
          <h3>Ошибка авторизации</h3>
        </div>
        <div className="auth-modal-body">
          <button className="auth-btn" onClick={handleStayGuest}>
            Продолжить как гость
          </button>
          <button className="auth-btn" onClick={handleLogin}>
            Войти заново
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;